export class SpinSession {
  private spinning = false;

  tryStart(): boolean {
    if (this.spinning) return false;
    this.spinning = true;
    return true;
  }

  complete(): void {
    this.spinning = false;
  }

  get isSpinning(): boolean {
    return this.spinning;
  }
}
